import React                from 'react';
import CSSModules           from 'react-css-modules';
import Helmet               from "react-helmet";
import { reduxForm }        from 'redux-form';
import { browserHistory }   from 'react-router';
import moment               from "moment";
import { GoogleMapLoader, GoogleMap, Marker } from 'react-google-maps';

import classnames from 'classnames/bind';

import resourcesRepo        from '../../services/resourcePacks';
import responseFormatter    from '../../services/responseFormatter';
import navigator            from "../../services/navigator";
import eventFormatter       from '../../services/eventFormatter';
import sessions             from '../../services/sessions';

import * as detailPageActions from '../../actions/detailPage';

import BreadcrumbTrail from "pattern-library/dist/js/components/BreadcrumbTrail";

import {
    PRESENTER_PICTURE_ENDPOINT,
    generateEndpoint
} from '../../services/endpoints';

import style from './style.scss';

import Accordion            from '../Accordion';
import EventAccordionTitle       from '../EventAccordionTitle';
import EventAccordionContent     from '../EventAccordionContent';
import EventSummary         from '../EventSummary';
import EventSummaryDateLine from '../EventSummaryDateLine';
import EventSummaryVenue    from '../EventSummaryVenue';
import Label                from '../Label';
import Input                from '../Input';
import Button               from '../Button';
import InlineError          from '../InlineError';
import DetailPageHeader     from '../DetailPageHeader';
import DetailPageTimetable     from '../DetailPageTimetable';

class DetailPage extends React.Component {

    componentDidMount() {

        this.props.refreshData();
    }

    componentWillUnmount() {

        this.props.resetEvent();
    }

    _isAccordionOpen(accordionKey) {

        return this.props.openAccordions.includes(accordionKey);
    }

    _toggleAccordion(accordionKey) {

        this.props.toggleAccordion(accordionKey);
    }

    _getTestimonialComponent(testimonial, key) {

        return (
            <div key={ key } styleName="testimonial">

                <div dangerouslySetInnerHTML={{ __html: "&ldquo;" + testimonial.content + "&rdquo;" }}
                     styleName="testimonial-content">
                </div>

                <span styleName="testimonial-author">
                    { testimonial.author_name }, { testimonial.organisation_name }
                </span>
            </div>
        )
    }

    _getTestimonialList() {

        return (
            this.props.testimonials.map((testimonial, index) => {

                return this._getTestimonialComponent(testimonial, index);
            })
        );
    }

    _getContainer() {

        return (
            <div className={ style['venue__map-container'] }></div>
        );
    }

    _setMapReference(map) {

        if (map) {

            this.map = map;
        }
    }

    _getMap() {

        var markerPosition = {
            lat: null,
            lng: null
        };

        const model = this.props.model;

        if (model && model.venue && model.venue.address) {

            markerPosition.lat = parseFloat(model.venue.address.latitude);
            markerPosition.lng = parseFloat(model.venue.address.longitude);
        }

        return (
            <GoogleMap ref={ this._setMapReference.bind(this) }
                       defaultZoom={ 15 }
                       defaultOptions={{ mapTypeControl: true, streetViewControl: true }}
                       center={ markerPosition }>

                { this._getAddress() }

                <Marker icon={ this._getMarker(this.props.moduleHexColour) }
                        position={ markerPosition }/>

            </GoogleMap>
        );
    }

    _getMarker(hexCode) {

        return {
            path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0',
            fillColor: hexCode,
            fillOpacity: 1,
            strokeColor: '#a5a5a5',
            strokeWeight: 1,
            scale: 1,
        };
    }

    _getAddress() {

        return (
            <address className={ style['venue__map-address'] }>
                <span className={ style['venue__address-line'] }>{ this.props.model.venue.address.address_1 }</span>

                {
                    this.props.model.venue.address.address_2 ? <span className={ style['venue__address-line'] }>{ this.props.model.venue.address.address_2 }</span> : null
                }

                <span className={ style['venue__address-line'] }>{ this.props.model.venue.address.town_city }</span>
                <span className={ style['venue__address-line'] }>{ this.props.model.venue.address.post_code }</span>
            </address>
        );
    }

    _getVenue() {

        if (this.props.model) {

            return (
                <GoogleMapLoader containerElement={ this._getContainer() }
                                 googleMapElement={ this._getMap() } />
            );
        }
    }

    _getPresenterImage(presenter) {

        if (presenter.profile_picture) {

            const presenterPictureUrl = generateEndpoint(PRESENTER_PICTURE_ENDPOINT, { id:  presenter.id });

            return <img styleName="presenter__picture" src={ presenterPictureUrl }/>
        }
    }

    _getPresenters() {

        if (this.props.model) {

            return (
                this.props.model.presenters.map((presenter, index) => {

                    return (
                        <div styleName="presenter" key={ index }>

                            { this._getPresenterImage(presenter) }

                            <h4 styleName="presenter-name">{ presenter.name }</h4>

                            <div dangerouslySetInnerHTML={{ __html: presenter.bio }}></div>

                        </div>
                    );
                })
            );
        }
    }

    _getPublicPrice() {

        if (this.props.model) {

            return parseFloat(this.props.model.public_price).toFixed(2);
        }
    }

    _getPrivatePrice() {

        if (this.props.model) {

            return parseFloat(this.props.model.private_price).toFixed(2);
        }
    }

    _getIsPriceOverridden() {

        if (this.props.model) {

            return this.props.model.overridden_price !== null;
        }
    }

    _getOverriddenPrice() {

        if (this.props.model && this.props.model.overridden_price !== null) {

            return parseFloat(this.props.model.overridden_price).toFixed(2);
        }

        return null;
    }

    _navigateToEventDetails(eventId, slug) {

        browserHistory.push(`/events/${ eventId }/${ slug }`);
    }

    _getEventSummaryDate(event) {

        if (event) {

            return (
                <div>
                    <EventSummaryDateLine>
                        { eventFormatter.getFormattedEventDate(event) }
                    </EventSummaryDateLine>
                    <EventSummaryDateLine>
                        { eventFormatter.getFormattedEventStartTime(event)}&ndash;{eventFormatter.getFormattedEventEndTime(event) }
                    </EventSummaryDateLine>
                </div>
            )
        }

        return null;
    }

    _getCustomiseModulesInfo() {
        return (
            <article styleName="event-summary__box"
                     style={{ backgroundColor: this.props.moduleHexColour }}>

                <h4 styleName="event-summary__box-heading">
                    Customise
                </h4>

                <p styleName="contact-box-text">
                    <span>Individual modules can be selected instead of the whole course during the booking process</span>
                </p>

            </article>
        );
    }

    _getContactUsInfo() {
        return (
            <article styleName="event-summary__box"
                     style={{ backgroundColor: '#000000' }}>

                <h4 styleName="event-summary__box-heading">
                    Contact RHE
                </h4>

                {!this.props.isELearningCourse &&
                    <p styleName="contact-box-text">
                        If you would like to arrange a class in your area,
                        please contact the training team on
                        <span styleName="contact-phone-number">
                            &nbsp;01239 711793&nbsp;
                        </span>or email <a styleName="contact-box-email" href="mailto:training@rheglobal.com">training@rheglobal.com</a>.
                    </p>
                }

                {this.props.isELearningCourse &&
                    <p styleName="contact-box-text">
                        If you would like more information about our e-Learning courses,
                        please contact the training team on
                        <span styleName="contact-phone-number">
                            &nbsp;01239 711793&nbsp;
                        </span>or email <a styleName="contact-box-email" href="mailto:training@rheglobal.com">training@rheglobal.com</a>.
                    </p>
                }

            </article>
        );
    }

    _getRelatedEvents() {

        if (this.props.upcomingEvents.length > 0) {

            let events = this.props.upcomingEvents;

            if (this.props.pageType === 'event') {
                events = events.filter((event) => event.id !== this.props.model.id);
            }

            return (
                events.map((upcomingEvent, index) => {

                    const formattedEvent = eventFormatter.format(upcomingEvent);

                    return (
                        <EventSummary key={ index }
                                      onClick={ this._navigateToEventDetails.bind(this, upcomingEvent.id, upcomingEvent.course.slug) }
                                      event={ formattedEvent }
                                      className={ style['event-summary__box'] }
                                      moduleHexColour={ this.props.moduleHexColour }
                                      inHouse={ false }>

                            {sessions(formattedEvent, this._getEventSummaryDate)}

                            {!formattedEvent.multiple_days && (
                                this._getEventSummaryDate(formattedEvent)
                            )}

                            {upcomingEvent.course.type !== "webinar" && (
                                <EventSummaryVenue>
                                    { formattedEvent.venue.address.address_1 }, { formattedEvent.venue.address.town_city }
                                </EventSummaryVenue>
                            )}

                        </EventSummary>
                    )
                })
            );
        }
    }

    _submitResourceAccessForm(formValues, dispatch) {

        return new Promise((resolve, reject) => {

            function getSuccess(response) {

                dispatch(detailPageActions.showResourcePacks(response.data.data));
            }

            function getFailed(response) {

                reject(responseFormatter.apiErrorsToFormErrors(response.data.errors));
            }

            resourcesRepo.getByCode(formValues.code)
                .then(getSuccess, getFailed)
        });
    }

    _getResourceAccessForm() {

        const { fields: { code }, handleSubmit } = this.props;

        return (
            <form onSubmit={ handleSubmit(this._submitResourceAccessForm.bind(this)) }>

                <p>
                    The Delegate Resources for this training event can be downloaded here and will
                    be available for up to one calendar month after the event date.
                    These resources are copyrighted and should not be used other than by the
                    delegate for the purposes of this course.
                </p>

                <p>
                    Please enter the code provided to you on this course to access the resources.
                </p>

                <Label>Access Code</Label>

                <Input { ...code } errors={ code.error } />

                <InlineError errors={ code.error } />

                <Button type="submit"
                        styleName="resources__submit-button">
                    Submit
                </Button>

            </form>
        );
    }

    _getResourcePackList() {

        if (this.props.resourcePacks.length > 0) {

            const accessCode = this.props.fields.code.value;

            return (

                <ul styleName="pack-list">

                    {
                        this.props.resourcePacks.map((pack, index) => {

                            const downloadAllLink = '/api/v1/packs/' + pack.id + '/download?code=' + accessCode;

                            if (pack.files.length > 0) {

                                return (
                                    <li styleName="pack-item" key={ index }>

                                        <span styleName="pack-name">{ pack.name }</span>

                                        <a styleName="download-link" href={ downloadAllLink }>Download All</a>

                                        <ul>

                                            {
                                                pack.files.map((file) => {

                                                    const downloadLink = '/api/v1/files/' + file.id + '/download?code=' + accessCode;

                                                    return (
                                                        <li>
                                                            <span>{ file.name }</span>
                                                            <a styleName="download-link" href={ downloadLink }>Download</a>
                                                        </li>
                                                    )
                                                })
                                            }

                                        </ul>
                                    </li>
                                );
                            }
                        })
                    }

                </ul>
            );

        } else {

            return (
                <span>No delegate resources have been uploaded yet.</span>
            );
        }
    }

    _getOverviewClass(name) {

        var cx = classnames.bind(style);

        return cx({
            'accordion-content-container': true,
            [name]:true
        });
    }

    _getVenueAccordion() {

        if (this.props.showVenueAccordion === true && this.props.courseType !== "webinar") {

            return (
                <Accordion className='event-accordion'>

                    <EventAccordionTitle onClick={ this._toggleAccordion.bind(this, 'venue') }
                                         expanded={ this._isAccordionOpen('venue') }
                                         moduleHexColor={this.props.moduleHexColour }
                    >
                        Venue
                    </EventAccordionTitle>

                    <EventAccordionContent expanded={ this._isAccordionOpen('venue') }>

                        { this._getVenue() }

                    </EventAccordionContent>

                </Accordion>
            );
        }
    }

    _shouldShowTimetable() {

        if (this.props.isELearningCourse || !this.props.model) {
            return false;
        }

        const model = this.props.model;

        if (model.multiple_days) {

            for (let i = 0; i < model.multiple_days_events.length; i++) {
                if (model.multiple_days_events[i].timetable_id) {
                    return true;
                }
            }

            return false;
        }

        return this.props.model.timetable;
    }

    render() {

        const titleSelectionRegex = /(Module \d+): (.*)/gi;

        return (
            <article className={style['section-content']}>

                <Helmet>
                    <title>{this.props.courseName}</title>
                    <meta name="description" content={this.props.courseOverview}/>
                </Helmet>

                <BreadcrumbTrail
                    callback={crumbUrl => navigator.push(crumbUrl)}
                    className={style['rhe-breadcrumb']}
                    crumbs={[
                        {
                            title: this.props.breadcrumbs.props.children[0].props.children,
                            url: this.props.breadcrumbs.props.children[0].props.to
                        },
                        {
                            title: this.props.breadcrumbs.props.children[1].props.children
                        }
                    ]}
                />

                <div className={style['event-container']}>
                    <article className={style['event-details-col']}>
                        <DetailPageHeader
                            courseType={this.props.courseType}
                            moduleHexColor={ this.props.moduleHexColour}
                            publicPrice={ this._getPublicPrice() }
                            privatePrice={ this._getPrivatePrice() }
                            moduleName={ this.props.moduleName }
                            isELearningCourse={this.props.isELearningCourse}
                            courseName={ this.props.courseName }
                            featuredTestimonial={this.props.featuredTestimonial}
                            cpdHours={this.props.cpdHours}
                            cpdMinutes={this.props.cpdMinutes}
                            isFullyBooked={this.props.fullyBooked}
                            showBookingButton={(!this.props.fullyBooked && this.props.allowBookings && this.props.bookingButtonLink) || this.props.isELearningCourse}
                            buttonLink={this.props.isELearningCourse ? `/booking/elearning/${ this.props.model.id }` : this.props.bookingButtonLink}
                            shortLocation={this.props.shortLocation}
                            formattedEvent={ this.props.formattedEvent }
                            overriddenPrice={ this._getOverriddenPrice() }
                        />

                        <Accordion className='event-accordion'>

                            <EventAccordionTitle onClick={ this._toggleAccordion.bind(this, 'overview') }
                                                 expanded={ this._isAccordionOpen('overview') }
                                                 moduleHexColor={this.props.moduleHexColour }
                                                >
                                Overview
                            </EventAccordionTitle>

                            <EventAccordionContent expanded={ this._isAccordionOpen('overview') }>
                                {this.props.model && (this.props.model.multiple_days && this.props.model.multiple_days_events.length > 2) && (
                                        <div>
                                            <h3 className={style['event-date-title']}>Event dates:</h3>
                                            <ul>
                                                {this.props.model.multiple_days_events.map((day, i) => <li key={i}>{moment(day.start_date).format('Do MMMM YYYY HH:mm')} - {moment(day.end_date).format('HH:mm')}</li>)}
                                            </ul>
                                        </div>
                                    )
                                }

                                <div className={ this._getOverviewClass('course-overview') }
                                     dangerouslySetInnerHTML={{ __html: this.props.courseOverview }}>
                                </div>

                            </EventAccordionContent>

                        </Accordion>

                        {this.props.isELearningCourse && this.props.model && this.props.model.sorted_elearning_units.length > 0 &&
                            <Accordion className='event-accordion'>

                                <EventAccordionTitle onClick={ this._toggleAccordion.bind(this, 'modules') }
                                                     expanded={ this._isAccordionOpen('modules') }
                                                     moduleHexColor={this.props.moduleHexColour }
                                >
                                    Modules
                                </EventAccordionTitle>

                                <EventAccordionContent expanded={ this._isAccordionOpen('modules') }>

                                    <section className={style['accordion-content-container']}>
                                        {this.props.model.sorted_elearning_units.filter(u => u.type === 'module').map(unit => {
                                            return (
                                                <div className={style['module-detail']}>
                                                    <h4 className={style['module-detail__index-heading']} style={{ color: this.props.moduleHexColour }}>{ unit.title.replace(titleSelectionRegex, '$1') }</h4>
                                                    <h5 className={style['module-detail__name-heading']}>{ unit.title.replace(titleSelectionRegex, '$2') }</h5>

                                                    {(unit.cpd_hours > 0 || unit.cpd_minutes > 0) &&
                                                        <span className={style['module-detail__cpd-heading']}>CPD { unit.cpd_hours > 0 && unit.cpd_hours + ' hours and' } { unit.cpd_minutes } minutes</span>
                                                    }

                                                    <p
                                                        className={style['module-detail__description']}
                                                        dangerouslySetInnerHTML={{ __html: unit.description }}>
                                                    </p>
                                                </div>
                                            )
                                        })}
                                    </section>

                                </EventAccordionContent>

                            </Accordion>
                        }

                        {(this.props.model && this.props.model.presenters.length > 0) && (
                            <Accordion className='event-accordion'>

                                <EventAccordionTitle onClick={ this._toggleAccordion.bind(this, 'presenters') }
                                                     expanded={ this._isAccordionOpen('presenters') }
                                                     moduleHexColor={this.props.moduleHexColour }
                                >
                                    {this.props.isELearningCourse ? 'Authors' : 'Presenters'}
                                </EventAccordionTitle>

                                <EventAccordionContent expanded={ this._isAccordionOpen('presenters') }>

                                    <section className={style['accordion-content-container']}>
                                        { this._getPresenters() }
                                    </section>

                                </EventAccordionContent>

                            </Accordion>
                        )}

                        { this._getVenueAccordion() }

                        {this._shouldShowTimetable() && (<Accordion className='event-accordion'>

                            <EventAccordionTitle onClick={ this._toggleAccordion.bind(this, 'timetable') }
                                                 expanded={ this._isAccordionOpen('timetable') }
                                                 moduleHexColor={this.props.moduleHexColour }
                            >
                                Timetable
                            </EventAccordionTitle>

                            <EventAccordionContent expanded={ this._isAccordionOpen('timetable') }>

                                <article className={style['accordion-content-container']}>

                                    <div className={style['timetable']}>
                                        <DetailPageTimetable model={this.props.model} />

                                        <p className={style['timetable-disclaimer']}>
                                            Please note that this timetable is indicative only.
                                            The presenter will be guided by the needs and interests of
                                            participants and the common problems being faced by practitioners
                                        </p>
                                    </div>
                                </article>

                            </EventAccordionContent>

                        </Accordion>)}


                        {this.props.showResourcePacks &&
                        <Accordion className='event-accordion'>

                            <EventAccordionTitle onClick={ this._toggleAccordion.bind(this, 'resources') }
                                                 expanded={ this._isAccordionOpen('resources') }
                                                 moduleHexColor={this.props.moduleHexColour }
                            >
                                Delegate Resources
                            </EventAccordionTitle>

                            <EventAccordionContent expanded={ this._isAccordionOpen('resources') }>

                                <article className={style['accordion-content-container']}>
                                    { this.props.isResourceCodeSubmitted ? this._getResourcePackList() : this._getResourceAccessForm() }
                                </article>

                            </EventAccordionContent>

                        </Accordion>
                        }

                        {this.props.testimonials.length > 0 &&
                            <Accordion className='event-accordion'>

                                <EventAccordionTitle onClick={ this._toggleAccordion.bind(this, 'testimonials') }
                                                     expanded={ this._isAccordionOpen('testimonials') }
                                                     moduleHexColor={this.props.moduleHexColour }
                                >
                                    Testimonials
                                </EventAccordionTitle>

                                <EventAccordionContent expanded={ this._isAccordionOpen('testimonials') }>

                                    <section className={style['accordion-content-container']}>
                                        { this._getTestimonialList() }
                                    </section>

                                </EventAccordionContent>

                            </Accordion>
                        }

                        {!this.props.isELearningCourse && (<Accordion className='event-accordion'>

                            <EventAccordionTitle onClick={ this._toggleAccordion.bind(this, 'delivery') }
                                                 expanded={ this._isAccordionOpen('delivery') }
                                                 moduleHexColor={this.props.moduleHexColour }
                            >
                                Delivery of Events
                            </EventAccordionTitle>

                            <EventAccordionContent expanded={ this._isAccordionOpen('delivery') }>

                                <section className={style['accordion-content-container']}>

                                    <p>
                                        Some of our training courses are delivered in public spaces but most are hosted in our customers premises.
                                    </p>

                                    <span className={style['delivery-heading']}>Why host?</span>

                                    <p>
                                        Hosting a training course means not having to travel to an event, saving both time and money. Depending upon your needs and choices hosting a training course can also produce significant savings on actual attendance costs. We can offer two hosting options.
                                    </p>

                                    <span className={style['delivery-heading']}>Option 1</span>

                                    <p>
                                        The reciprocal arrangement is a good choice for those who want to reduce the cost of training whilst expending minimum effort. In return for use of a training room and some equipment, the host organisation receives one free place and a 10% discount on any other places provided they are booked at the same time. Under this arrangement delegates are provided with refreshments and lunch. We would need some help with organising this but RHE would cover the cost. In light of your local knowledge we would also ask your advice on some aspects of the joining instructions.
                                    </p>

                                    <p>
                                        With this option, we would take care of all the bookings and administration but we might need some help with marketing. RHE offers online resources in support of the training before and after the event and CPD certificates are awarded on the day.
                                    </p>

                                    <span className={style['delivery-heading']}>Option 2</span>

                                    <p>
                                        The in-house arrangement is a good choice for those who have several colleagues in need of the same training or where you want to tailor training to meet a specific need. The fixed fee covers a particular number of delegates and any spare places can be sold on, making this a very cost effective way of fulfilling training needs. In this case you would be responsible for filling the places, although we will help with this - and for provision of catering. For your information lunch is included in RHE prices.
                                    </p>

                                    <p>
                                        As above, you would need to provide a suitable room and some equipment. RH Environmental will support you by providing printed materials, and will produce joining instructions. Online resources in support of the training are offered before and after the event and CPD certificates are awarded on the day. Prices for the in-house arrangement are agreed on a case-by-case basis depending upon the course and numbers of delegates.
                                    </p>

                                </section>

                            </EventAccordionContent>

                        </Accordion>)}

                        <Accordion className='event-accordion'>

                            <EventAccordionTitle onClick={ this._toggleAccordion.bind(this, 'cpd') }
                                                 expanded={ this._isAccordionOpen('cpd') }
                                                 moduleHexColor={this.props.moduleHexColour }

                            >
                                CPD Hours
                            </EventAccordionTitle>

                            <EventAccordionContent expanded={ this._isAccordionOpen('cpd') }>

                                <p className={style['accordion-content-container']}>
                                    Certificates of attendance will be awarded to participants. This course qualifies for&nbsp;
                                    <span className={style['accordion__cpd-time']}>
                                        { this.props.cpdHours } hours and { this.props.cpdMinutes } minutes
                                    </span>&nbsp;of core CPD time.
                                </p>

                            </EventAccordionContent>

                        </Accordion>

                        {!this._getIsPriceOverridden() &&

                        <Accordion className='event-accordion'>

                            <EventAccordionTitle onClick={ this._toggleAccordion.bind(this, 'cost') }
                                                 expanded={ this._isAccordionOpen('cost') }
                                                 moduleHexColor={this.props.moduleHexColour }
                            >
                                Costs
                            </EventAccordionTitle>

                            <EventAccordionContent expanded={ this._isAccordionOpen('cost') }>

                                {!this.props.isELearningCourse &&
                                    <article className={style['accordion-content-container']}>
                                        <span className={style['cost-line']}>&pound;{this._getPublicPrice()} (+VAT) Public Sector</span>
                                        <span className={style['cost-line']}>&pound;{this._getPrivatePrice()} (+VAT) Private Sector</span>
                                    </article>
                                }

                                {this.props.isELearningCourse &&
                                    <article className={style['accordion-content-container']}>
                                        <div className={style['e-learning-cost-table-container']}>
                                            <table className={style['e-learning-cost-table']}>
                                                <thead>
                                                <th></th>
                                                <th>Public Sector<br/>(+VAT)</th>
                                                <th>Private Sector<br/>(+VAT)</th>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td><strong>Whole Course</strong></td>
                                                    <td>&pound;{this._getPublicPrice()}</td>
                                                    <td>&pound;{this._getPrivatePrice()}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </article>
                                }

                                {this.props.isELearningCourse &&
                                    <article className={style['accordion-content-container']}>
                                        <div className={style['e-learning-cost-table-container']}>
                                            <table className={style['e-learning-cost-table']}>
                                                <thead>
                                                <th></th>
                                                <th></th>
                                                <th></th>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td><strong>Per Module</strong></td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td>1 +</td>
                                                    <td>£25.00</td>
                                                    <td>£25.00</td>
                                                </tr>
                                                <tr>
                                                    <td>4 +</td>
                                                    <td>£22.00</td>
                                                    <td>£22.00</td>
                                                </tr>
                                                <tr>
                                                    <td>7 +</td>
                                                    <td>£18.00</td>
                                                    <td>£18.00</td>
                                                </tr>
                                                <tr>
                                                    <td>10 +</td>
                                                    <td>£15.00</td>
                                                    <td>£15.00</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </article>
                                }

                                <article className={style['promotion-details']}>
                                    <div
                                        className={ this._getOverviewClass('promotion-details--container') }
                                        dangerouslySetInnerHTML={{ __html: this.props.promotionalDetails }}
                                    >
                                    </div>
                                </article>

                            </EventAccordionContent>

                        </Accordion>
                        }

                    </article>

                    <div className={style['event-summary__col-container']}>

                        {!this.props.isELearningCourse && (
                            <h3 className={style['event-summary-col-header']}>Schedule</h3>
                        )}

                        <article className={style['event-summary-col']}>

                            { !this.props.isELearningCourse && this._getRelatedEvents() }
                            { this.props.isELearningCourse && !this._getIsPriceOverridden() && this._getCustomiseModulesInfo() }
                            { this._getContactUsInfo() }

                        </article>

                    </div>
                </div>

                <div id="event-summary" className={style['event-summary--mobile']}>
                    {!this.props.isELearningCourse && (
                        <h3 className={style['event-summary-col-header--mobile']}>Schedule</h3>
                    )}
                    { !this.props.isELearningCourse && this._getRelatedEvents() }
                    { this.props.isELearningCourse && !this._getIsPriceOverridden() && this._getCustomiseModulesInfo() }
                    { this._getContactUsInfo() }
                </div>

            </article>
        );
    }
}

function mapStateToProps(state) {

    return {
        ...state.detailPage,
        initialValues: {
            code: ''
        }
    };
}

function mapDispatchToProps(dispatch) {

    return {
        resetEvent() {

            dispatch(detailPageActions.resetEvent());
        },
        toggleAccordion(accordionKey) {

            dispatch(detailPageActions.toggleAccordion(accordionKey));
        }
    };
}

const formParams = {
    form: 'delegate-resources',
    fields: [
        'code'
    ]
};

export default reduxForm(formParams, mapStateToProps, mapDispatchToProps)(CSSModules(DetailPage, style));


// WEBPACK FOOTER //
// ./components/DetailPage/index.js